import uniq from 'lodash/uniq'
import { createReducer } from 'redux-create-reducer'
import type { NativeCategory } from 'types/track'
import {
  NATIVE_TAGS_EDIT,
  PRELOAD_DATA_ON_LOGIN,
} from '@disco/constants/ActionTypes'
export type NativeCategoriesState = {
  [key in NativeCategory['id']]?: NativeCategory
}
const initialState: NativeCategoriesState = {}
export const nativeCategoriesReducer = createReducer<
  NativeCategoriesState,
  any
>(initialState, {
  [PRELOAD_DATA_ON_LOGIN](_state, action) {
    return action.entities.nativeCategories ?? initialState
  },

  [NATIVE_TAGS_EDIT](state, action) {
    const updatedState = { ...state }

    if (action.id && action.category_id) {
      const category = updatedState[action.category_id]
      if (category) {
        updatedState[action.category_id] = {
          ...category,
          native_tags: category.native_tags.filter(id => id !== action.id),
        }
      }
    }

    if (action.tag) {
      const category = updatedState[action.tag.category_id]
      if (category) {
        updatedState[action.tag.category_id] = {
          ...category,
          native_tags: uniq([...category.native_tags, action.tag.id]),
        }
      }
    }

    return updatedState
  },
})
